module.exports = __webpack_public_path__ + "static/media/pencil-green.81449978.svg";